import React from 'react';
import { Container, Row, Col, Alert, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Row>
        <Col className="text-center">
          <Alert color="danger">
            <h4 className="alert-heading">Access Denied</h4>
            <p>You are not authorized to view this page.</p>
          </Alert>
          <Button color="primary" onClick={() => navigate('/')}>Go to Home</Button>
        </Col>
      </Row>
    </Container>
  );
};

export default NotAuthorized;
